// Ponto de entrada do front portado (bundle iife pelo esbuild).
// A marcação usa onclick="fn()" como o protótipo, então as funções de tela ficam em window.

import { enviarPendentes } from './fila.js';
import * as V from './vistoriador.js';
import * as SH from './gestao-shell.js';
import * as D from './gestao-dash.js';
import * as H from './gestao-hist.js';

// ── PWA Service Worker ───────────────────────────────────────────────────────
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/sw.js').then(function (reg) {
      try { reg.update(); } catch (e) { /* sem update */ }
      setInterval(function () { try { reg.update(); } catch (e) { /* sem update */ } }, 30 * 60 * 1000);
      reg.addEventListener('updatefound', function () {
        const nw = reg.installing; if (!nw) return;
        nw.addEventListener('statechange', function () {
          if (nw.state === 'installed' && navigator.serviceWorker.controller) {
            try { nw.postMessage({ type: 'SKIP_WAITING' }); } catch (e) { /* worker já ativo */ }
          }
        });
      });
    }).catch(function () { /* sem service worker */ });
    let _swReloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', function () {
      if (_swReloaded) return; _swReloaded = true; location.reload();
    });
  });
}

// PWA install prompt
let _deferredInstall: any = null;
window.addEventListener('beforeinstallprompt', function (e) {
  e.preventDefault();
  _deferredInstall = e;
  setTimeout(showInstallBtn, 1000);
});
function showInstallBtn() {
  if (!_deferredInstall) return;
  const btn = document.getElementById('pwa-install-btn');
  if (btn) btn.style.display = 'flex';
}
function installPWA() {
  if (!_deferredInstall) return;
  _deferredInstall.prompt();
  _deferredInstall.userChoice.then(function (result: any) {
    if (result.outcome === 'accepted') _deferredInstall = null;
    const btn = document.getElementById('pwa-install-btn');
    if (btn) btn.style.display = 'none';
  });
}

/** Marca a área no endereço para o login Microsoft voltar ao lugar certo (/auth/entrar?volta=). */
function marcar(area: string) { try { history.replaceState(null, '', '/#' + area); } catch (e) { /* sem history */ } }
function irVistoria() { marcar('vistoria'); return V.showObras(); }
function irGestao() { marcar('gestao'); return SH.showAdminLogin(); }
function inicio() { try { history.replaceState(null, '', '/'); } catch (e) { /* sem history */ } V.renderHome(); }

Object.assign(window as any, {
  S: V.S,
  installPWA,
  renderHome: inicio,
  showObras: irVistoria,
  showAdminLogin: irGestao,
  pickAloj: V.pickAloj,
  escolherSemana: V.escolherSemana,
  mudarComp: V.mudarComp,
  iniciarVistoria: V.iniciarVistoria,
  anexarVistoria: V.anexarVistoria,
  setSt: V.setSt,
  setObs: V.setObs,
  pickPhotos: V.pickPhotos,
  rmPh: V.rmPh,
  pickGen: V.pickGen,
  rmGen: V.rmGen,
  doSubmit: V.doSubmit,
  admLogout: SH.admLogout,
  globalSearchInput: SH.globalSearchInput,
  globalSearchBlur: SH.globalSearchBlur,
  pararAtualizacaoGestao: SH.pararAtualizacaoGestao,
  renderAdmin: SH.renderAdmin,
  abrirTodasObras: D.abrirTodasObras,
  toggleObra: D.toggleObra,
  toggleAllHist: H.toggleAllHist,
  updateHistSel: H.updateHistSel,
  approveSelectedHist: H.approveSelectedHist,
  rejectSelectedHist: H.rejectSelectedHist,
  deleteSelectedHist: H.deleteSelectedHist,
  approvePDFById: H.approvePDFById,
  rejectById: H.rejectById,
  seePDFById: H.seePDFById,
  verFotosById: H.verFotosById,
  notificarColaboradorById: H.notificarColaboradorById,
  delSubById: H.delSubById,
});

// START
function _init() {
  const area = (location.hash || '').replace('#', '');
  try {
    if (area === 'gestao') irGestao();
    else if (area === 'vistoria') irVistoria();
    else V.renderHome();
  } catch (e) { console.error('renderHome error:', e); }
  // fila de envio (protótipo: retryOutbox no início, ao voltar a rede, ao reabrir e a cada 60 s)
  setTimeout(function () { enviarPendentes().catch(function () { /* tenta depois */ }); }, 500);
  window.addEventListener('online', function () { enviarPendentes().catch(function () { /* tenta depois */ }); });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) enviarPendentes().catch(function () { /* tenta depois */ });
  });
  setInterval(function () { enviarPendentes().catch(function () { /* tenta depois */ }); }, 60000);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', _init);
else _init();
